import type { DefaultTheme } from 'styled-components';
import { colorsSource } from './colors';

const tone = colorsSource['neutral-variant'];

// The legacy light surfaces are warm beige; the Apps pages use the brand's neutral-variant greys instead.
export const applyAppsTheme = (base: DefaultTheme): DefaultTheme =>
  base.isLightTheme
    ? {
        ...base,
        colors: {
          ...base.colors,
          surfaceDim: tone['90'],
          surfaceContainerLowest: tone['100'],
          surfaceContainerLow: tone['98'],
          surfaceContainer: tone['95'],
          surfaceContainerHigh: tone['90'],
          surfaceContainerHighest: tone['80'],
          outline: tone['50'],
          outlineVariant: tone['80'],
        },
      }
    : base;
